import { render, staticRenderFns } from "./HvStat.vue?vue&type=template&id=0d0073bf"
import script from "./HvStat.vue?vue&type=script&lang=js"
export * from "./HvStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports